<script setup lang="ts">
import BalanceTransactionsTable from '@/components/asicw/tables/BalanceSheetTable.vue'
import ViewLayout from '@/views/layouts/ViewLayout.vue'
</script>

<template>
  <ViewLayout>
    <BalanceTransactionsTable />
  </ViewLayout>
</template>
